interface IProps {
    className?: string;
    tooltipText?: string;
}

export const BaseInfo = ({ className, tooltipText }: IProps) => (
    <svg
        className={className}
        data-tip={tooltipText}
        version="1.1"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g fillRule="evenodd" id="Page-1" stroke="none" strokeWidth="1">
            <g fillRule="nonzero" id="iconmonstr-info-2">
                <path
                    d="M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z M12,0 C5.373,0 0,5.373 0,12 C0,18.627 5.373,24 12,24 C18.627,24 24,18.627 24,12 C24,5.373 18.627,0 12,0 Z M13,18 L11,18 L11,10 L13,10 L13,18 Z M12,5.75 C12.69,5.75 13.25,6.31 13.25,7 C13.25,7.69 12.69,8.25 12,8.25 C11.31,8.25 10.75,7.69 10.75,7 C10.75,6.31 11.31,5.75 12,5.75 Z"
                    id="Shape"
                />
            </g>
        </g>
    </svg>
);
